import { useContext } from 'react';
import { AuthContext } from '@contexts/authContext.internal';

export interface ICurrentActor {
  /** The signed-in user's id — the same id the server stamps as `by` / `authorId`. */
  id: string;
  /** What the server stamps as the author name: the username. */
  name: string;
}

/**
 * Who is acting, for OPTIMISTIC log/comment entries the server will overwrite
 * with its own session-derived stamp. Replaces the old `MOCK_CURRENT_USER`
 * ("佐藤 健一"), which put a fake author on every comment and log line.
 *
 * Reads the context leniently (no throw outside a provider): panels render in
 * tests without auth, and an unknown actor is harmless for an optimistic stamp.
 */
export function useCurrentActor(): ICurrentActor {
  const user = useContext(AuthContext)?.user;
  return { id: user?.id ?? '', name: user?.username ?? '' };
}
